export const MCP_PRODUCT_NAME = 'AI Connector';
export const MCP_PRODUCT_NAME_PLURAL = 'AI Connectors';
